import script from "./PatientFieldDiscrepancy.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientFieldDiscrepancy.vue?vue&type=script&setup=true&lang=js"

import "./PatientFieldDiscrepancy.vue?vue&type=style&index=0&id=bfb4de92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfb4de92"]])

export default __exports__